<template>
    <vx-card class="h-full">
        <div class="card-title">
            <h2>{{chartTitle}}</h2>
            <!-- <vs-button
                @click="popupActive = true"
                color="gray"
                type="flat"
                icon-pack="feather"
                icon="icon-help-circle"
                class="p-0 help-btn"
            ></vs-button> -->
        </div>
        <vue-apex-charts :type="chartType" :height="chartHeight" :options="firstTimeOrReturnVisitorChart.chartOptions" :series="firstTimeOrReturnVisitorChart.series"></vue-apex-charts>
    </vx-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
    components: {
        VueApexCharts,
    },
    props:{
        chartTitle:{
            required: true
        },
        chartType:{
            required: true
        },
        chartHeight:{
            required: true
        },
        seriesNameOne:{
            required: true
        },
        seriesDataOne:{
            required: true
        },
        seriesNameTwo:{
            required: true
        },
        seriesDataTwo:{
            required: true
        },
        optionsXaxis:{
            required: true
        }
    },
    watch : {
        seriesDataOne : function () {
            this.firstTimeOrReturnVisitorChart.series = [{
                    name: this.seriesNameOne,
                    data: this.seriesDataOne
                },
                {
                    name: this.seriesNameTwo,
                    data: this.seriesDataTwo
                }
            ];
            this.firstTimeOrReturnVisitorChart.chartOptions = {
                ...this.firstTimeOrReturnVisitorChart.chartOptions,
                ...{
                    xaxis: {
                        categories: this.optionsXaxis,
                    }
                }
            };
        }
    },
    data (){
        let uid = this.$route.params.id;
        let VVtoken = localStorage.getItem("VVtoken");
        let token = JSON.parse(VVtoken);
        return {
            firstTimeOrReturnVisitorChart: {
                series: [
                    {
                        name: this.seriesNameOne,
                        data: this.seriesDataOne
                    },
                    {
                        name: this.seriesNameTwo,
                        data: this.seriesDataTwo
                    }
                ],
                chartOptions: {
                    legend: {
                        position: "bottom",
                        fontSize: "12px",
                        fontFamily: '"Montserrat", Helvetica, Arial, sans-serif',
                        itemMargin: {
                            horizontal: 20,
                            vertical: 10
                        },
                        onItemClick: {
                            toggleDataSeries: true
                        },
                        markers: {
                            width: 12,
                            height: 12,
                            radius: 2
                        }
                    },
                    colors: [
                        token[uid].themeDetail.tempChartColor1,
                        token[uid].themeDetail.tempChartColor3,
                    ],
                    plotOptions: {
                        bar: {
                            endingShape: "rounded",
                            columnWidth: "55%"
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ["transparent"]
                    },
                    xaxis: {
                        categories: []
                    },
                    yaxis:{
                        labels: {
                            formatter: function (val) {
                                return parseInt(val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            },
                        },
                    },
                    grid: {
                        show: true,
                        borderColor: "#f2f2f2",
                        strokeDashArray: 3,
                        position: "back",
                        xaxis: {
                            lines: {
                                show: false
                            }
                        }
                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            },
                        },
                    },
                }
            },
        }
    }    
}
</script>